// extracted by mini-css-extract-plugin
export default {"wrapper":"Dz-z","viewport":"Ez-z","container":"Fz-z","slide":"Gz-z"};